var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidentRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_V5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0---MDR---Incident-Dashboard_V3",
    transform: "translate(-1301.000000, -516.000000)",
    fill: "#EB3F56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1066.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "diagonal-arrow-right-up",
    transform: "translate(227.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0130661,9.31612426 C25.7375601,9.04068022 25.3638928,8.88593778 24.9742686,8.88593778 L13.2216295,8.8125 C12.8320053,8.8125 12.4583394,8.96724314 12.1828335,9.24268718 C11.9073276,9.51813122 11.7525497,9.89171322 11.7525497,10.2812499 C11.7525497,10.6707867 11.9073276,11.0443687 12.1828335,11.3198127 C12.4583394,11.5952567 12.8320053,11.7499999 13.2216295,11.7499999 L21.3897143,11.7499999 L9.240423,23.9259382 C9.10272845,24.0624776 8.99343767,24.2249214 8.91885442,24.4039022 C8.84427118,24.582883 8.80587167,24.7748569 8.80587167,24.9687494 C8.80587167,25.1626418 8.84427118,25.3546157 8.91885442,25.5335965 C8.99343767,25.7125773 9.10272845,25.8750211 9.240423,26.0115605 C9.37699305,26.1492241 9.53947476,26.2584931 9.71849573,26.3330596 C9.89751671,26.4076261 10.0895338,26.4460156 10.2834698,26.4460156 C10.4774058,26.4460156 10.6694228,26.4076261 10.8484438,26.3330596 C11.0274648,26.2584931 11.1899465,26.1492241 11.3265165,26.0115605 L23.5051887,13.8356249 L23.5051887,22.0312495 C23.5051887,22.4207862 23.6599652,22.7943682 23.9354711,23.0698122 C24.210977,23.3452563 24.5846444,23.4999994 24.9742686,23.4999994 C25.3638928,23.4999994 25.7375601,23.3452563 26.0130661,23.0698122 C26.288572,22.7943682 26.4433485,22.4207862 26.4433485,22.0312495 L26.4433485,10.3546877 C26.4433485,9.965151 26.288572,9.59156829 26.0130661,9.31612426 Z",
    id: "Vector",
    transform: "translate(17.624610, 17.629258) rotate(0.000000) translate(-17.624610, -17.629258) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentRedArrow);
export default __webpack_public_path__ + "static/media/IncidentRedArrow.bccc183ab2bd3b0c96104b02da88092e.svg";
export { ForwardRef as ReactComponent };